document.addEventListener("DOMContentLoaded", () => {
  const track = document.getElementById("carouselTrack");
  const prevBtn = document.getElementById("prevBtn");
  const nextBtn = document.getElementById("nextBtn");
  const coffeeTitle = document.getElementById("coffeeTitle");
  const shopButton = document.getElementById("shopButton");
  const trackWrapper = document.querySelector(".carousel-track");

  let isAnimating = false;
  let itemWidth;
  let touchStartX = 0;
  let touchEndX = 0;



  function updateItemWidth() {
    const style = getComputedStyle(track);
    const gap = parseFloat(style.gap || 0);
    itemWidth = track.children[0].offsetWidth + gap;
  }



function updateActive() {
  document.querySelectorAll(".carousel-item").forEach(el => el.classList.remove("active"));
  track.children[0].classList.add("active");

  const activeItem = track.children[0];
  coffeeTitle.textContent = activeItem?.dataset.name || '';
  shopButton.dataset.currentUrl = activeItem?.dataset.url || '#';

  const bgImage = activeItem?.dataset.bg;
  if (bgImage) {
    document.querySelector(".carousel-container").style.backgroundImage = `url('${bgImage}')`;
  }
  
  
  // Extract class like 'item-1'
  const itemClass = Array.from(activeItem.classList).find(cls => cls.startsWith('item-'));
  if (!itemClass) return;
  
    // Update arrows
  const arrows = document.querySelectorAll('.carousel-arrow');
  arrows.forEach(arrow => {
    // Remove any old item-X classes
    arrow.classList.forEach(cls => {
      if (cls.startsWith('item-')) arrow.classList.remove(cls);
    });
    // Add current item-X class
    arrow.classList.add(itemClass);
  });
  
}




function shift(direction) {
  if (isAnimating) return;
  isAnimating = true;

  updateItemWidth();

  if (direction === "left") {
    // Move first to end (prep)
    track.appendChild(track.firstElementChild);
    track.style.transition = "none";
    track.style.transform = `translateX(${itemWidth}px)`;
    void track.offsetWidth; // force reflow

    // Animate into place
    track.style.transition = "transform 0.3s ease";
    track.style.transform = "translateX(0)";
  } else {
    // Animate to right first
    track.style.transition = "transform 0.3s ease";
    track.style.transform = `translateX(${itemWidth}px)`;
  }

  track.addEventListener("transitionend", function handleTransition() {
    track.removeEventListener("transitionend", handleTransition);

    if (direction === "right") {
      // Move last to front
      track.prepend(track.lastElementChild);
      track.style.transition = "none";
      track.style.transform = "translateX(0)";
    }

    updateActive();
    isAnimating = false;
  });
}

function handleSwipeGesture() {
  const threshold = 50; // minimum px to trigger swipe
  const distance = touchEndX - touchStartX;

  if (Math.abs(distance) > threshold) {
    if (distance > 0) {
      // Swiped right → shift left (previous item)
      shift("right");
    } else {
      // Swiped left → shift right (next item)
      shift("left");
    }
  }
}



  prevBtn.addEventListener("click", () => shift("left"));
  nextBtn.addEventListener("click", () => shift("right"));


trackWrapper.addEventListener("touchstart", (e) => {
  touchStartX = e.changedTouches[0].screenX;
});

trackWrapper.addEventListener("touchend", (e) => {
  touchEndX = e.changedTouches[0].screenX;
  handleSwipeGesture();
});


  shopButton.addEventListener("click", () => {
    const url = shopButton.dataset.currentUrl;
    if (url) alert(`Would navigate to: ${url}`);
  });

  // Set initial state
  updateItemWidth();
  updateActive();
});